import { ROUTES } from '../lib/routes';
import { navigate } from '../router';
import { showModal, showToast } from '../components/toast';
import { el } from '../utils/dom';
import { submitEv123Lead } from '../api/submitEv123Lead';

export function renderConsultPage(root: HTMLElement): void {
  const wrap = el('div', { className: 'ev123-page-consult' });

  wrap.append(
    el('section', { className: 'ev123-section ev123-section--tight ev123-consult-hero' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-consult-hero__title', text: '전기차충전기 설치 상담 신청' }),
        el('p', {
          className: 'ev123-consult-hero__lead',
          text: '신규설치, 추가설치, 교체설치, 이전설치, 운영관리 상담이 필요하시면 내용을 남겨주세요. 담당자가 확인 후 연락드립니다.',
        }),
      ]),
    ])
  );

  const facility = textField('시설명 또는 주소', 'text', '입력해 주세요');
  const name = textField('담당자명', 'text', '이름');
  const phone = textField('연락처', 'tel', '010-0000-0000');
  const emailWrap = el('div', { className: 'ev123-field' });
  const emailInput = el('input', {
    className: 'ev123-input',
    type: 'email',
    placeholder: '선택',
    'aria-label': '이메일',
  }) as HTMLInputElement;
  emailWrap.append(
    el('label', { className: 'ev123-label', text: '이메일(선택)' }),
    emailInput,
    el('p', { className: 'ev123-field-hint', text: '회신이 필요하시면 입력해 주세요.' })
  );

  const typeSel = el('select', {
    className: 'ev123-select',
    'aria-label': '상담 희망 분야',
  }) as HTMLSelectElement;
  const types: [string, string][] = [
    ['new', '신규설치 검토'],
    ['add', '추가설치 검토'],
    ['replace', '교체설치 검토'],
    ['relocate', '이전설치 검토'],
    ['ops', '운영관리 상담'],
    ['revenue', '수익형충전기 검토'],
    ['other', '기타'],
  ];
  typeSel.appendChild(el('option', { value: '', text: '선택' }));
  for (const [v, t] of types) {
    typeSel.appendChild(el('option', { value: v, text: t }));
  }

  const body = el('textarea', {
    className: 'ev123-textarea ev123-textarea--consult',
    placeholder: '문의 내용을 입력해 주세요',
  }) as HTMLTextAreaElement;

  const privacyWrap = el('div', { className: 'ev123-field' });
  const privacyRow = el('div', { className: 'ev123-check-group' });
  const privacyChk = el('input', {
    type: 'checkbox',
    'aria-describedby': 'ev123-consult-privacy-hint',
  }) as HTMLInputElement;
  const privacyLabel = el('label', { className: 'ev123-label ev123-label--check' });
  privacyLabel.append(privacyChk, document.createTextNode(' 개인정보 수집·이용에 동의합니다 (필수)'));
  privacyRow.appendChild(privacyLabel);
  privacyWrap.append(
    privacyRow,
    el('p', {
      id: 'ev123-consult-privacy-hint',
      className: 'ev123-field-hint',
      text: '상담 처리를 위해 연락처와 문의 내용을 보관합니다.',
    })
  );

  const formInner = el('div', { className: 'ev123-consult-form-inner' });
  formInner.append(
    facility,
    name,
    phone,
    emailWrap,
    el('div', { className: 'ev123-field' }, [
      el('label', { className: 'ev123-label', text: '상담 희망 분야' }),
      typeSel,
    ]),
    el('div', { className: 'ev123-field' }, [
      el('label', { className: 'ev123-label', text: '문의 내용' }),
      body,
    ]),
    privacyWrap
  );

  const submit = el('button', {
    type: 'button',
    className: 'ev123-btn ev123-btn--primary ev123-btn--block ev123-btn--pill ev123-consult-submit',
  }) as HTMLButtonElement;
  submit.textContent = '상담 신청하기';

  const formCard = el('div', { className: 'ev123-card ev123-card--elevated ev123-consult-form-card' });
  formCard.append(
    el('p', {
      className: 'ev123-consult-form-lead',
      text: '아래 항목은 안내를 위한 기본 정보입니다. 잘 모르시는 항목은 비워 두셔도 됩니다.',
    }),
    formInner,
    submit
  );

  const briefList = el('ul', { className: 'ev123-consult-brief__list' });
  const briefItems = [
    '시설명 또는 주소',
    '주차면 수',
    '기존 충전기 현황',
    '희망 설치 방식',
    '문의 내용',
  ];
  for (const t of briefItems) {
    briefList.appendChild(el('li', { text: t }));
  }

  const briefCard = el('aside', { className: 'ev123-card ev123-card--elevated ev123-consult-brief' });
  briefCard.append(
    el('h2', { className: 'ev123-consult-brief__title', text: '상담 안내' }),
    briefList,
    el('p', {
      className: 'ev123-consult-brief__note',
      text: '정확한 정보가 없어도 괜찮습니다. 확인 가능한 내용만 남겨주시면 담당자가 순서대로 안내드립니다.',
    }),
    el('p', {
      className: 'ev123-consult-brief__emph',
      text: '정보가 부족해도 상담 신청은 가능합니다. 담당자가 확인 후 필요한 내용을 안내드립니다.',
    })
  );

  submit.addEventListener('click', async () => {
    const facIn = facility.querySelector('input') as HTMLInputElement | null;
    const nameIn = name.querySelector('input') as HTMLInputElement | null;
    const phoneIn = phone.querySelector('input') as HTMLInputElement | null;

    if (!facIn?.value?.trim()) {
      showToast('시설명 또는 주소를 입력해 주세요.');
      return;
    }
    if (!nameIn?.value?.trim()) {
      showToast('담당자명을 입력해 주세요.');
      return;
    }
    if (!phoneIn?.value?.trim()) {
      showToast('연락처를 입력해 주세요.');
      return;
    }
    if (!typeSel.value) {
      showToast('상담 희망 분야를 선택해 주세요.');
      return;
    }
    if (!body.value.trim()) {
      showToast('문의 내용을 입력해 주세요.');
      return;
    }
    if (!privacyChk.checked) {
      showToast('개인정보 수집·이용에 동의해 주세요.');
      return;
    }

    submit.disabled = true;
    const prevLabel = submit.textContent;
    submit.textContent = '접수 중…';
    try {
      await submitEv123Lead({
        name: nameIn.value.trim(),
        phone: phoneIn.value.trim(),
        apartment_or_company_name: facIn.value.trim(),
        inquiry_type: typeSel.value,
        message: body.value.trim(),
        privacy_agreed: true,
        email: emailInput.value.trim() || undefined,
      });
      showModal({
        title: '접수 완료',
        body: '상담 요청이 접수되었습니다. 빠른 시일 내에 연락드리겠습니다.',
        confirmLabel: '확인',
        onClose: () => navigate(ROUTES.homePublic),
      });
    } catch (e) {
      const msg = e instanceof Error ? e.message : '접수에 실패했습니다. 잠시 후 다시 시도해 주세요.';
      showToast(msg);
    } finally {
      submit.disabled = false;
      submit.textContent = prevLabel ?? '상담 신청하기';
    }
  });

  wrap.append(
    el('section', { className: 'ev123-section ev123-section--relaxed ev123-section--surface' }, [
      el('div', { className: 'ev123-container' }, [
        el('div', { className: 'ev123-consult-split' }, [briefCard, formCard]),
      ]),
    ])
  );

  const stepsWrap = el('div', { className: 'ev123-consult-steps' });
  const stepDefs: { n: string; title: string; desc: string }[] = [
    { n: '1', title: '상담 접수', desc: '남겨주신 내용을 확인합니다.' },
    { n: '2', title: '조건 확인', desc: '시설 유형, 주차면 수, 설치 목적을 검토합니다.' },
    { n: '3', title: '담당자 안내', desc: '설치 방향과 상담 일정을 안내드립니다.' },
  ];
  let stepIdx = 0;
  for (const s of stepDefs) {
    stepIdx += 1;
    const card = el('article', { className: 'ev123-consult-step' });
    card.append(
      el('span', { className: `ev123-badge ev123-badge--consult-${stepIdx}`, text: s.n }),
      el('h3', { className: 'ev123-consult-step__title', text: s.title }),
      el('p', { className: 'ev123-consult-step__desc', text: s.desc })
    );
    stepsWrap.appendChild(card);
  }

  wrap.append(
    el('section', { className: 'ev123-section ev123-section--tight' }, [
      el('div', { className: 'ev123-container' }, [
        el('h2', { className: 'ev123-consult-steps__heading', text: '상담 진행 절차' }),
        stepsWrap,
      ]),
    ])
  );

  const tel1544 = el('a', {
    className: 'ev123-consult-cta-bar__link',
    href: 'tel:1544-3610',
    text: '1544-3610',
  }) as HTMLAnchorElement;
  const tel010 = el('a', {
    className: 'ev123-consult-cta-bar__link',
    href: 'tel:010-8409-3610',
    text: '010-8409-3610',
  }) as HTMLAnchorElement;
  const mail = el('a', {
    className: 'ev123-consult-cta-bar__link ev123-consult-cta-bar__link--sub',
    href: 'mailto:linkcs@evcinfo.kr',
    text: 'linkcs@evcinfo.kr',
  }) as HTMLAnchorElement;

  const contacts = el('div', { className: 'ev123-consult-cta-bar__contacts' });
  contacts.appendChild(el('p', { className: 'ev123-consult-cta-bar__label', text: 'EV종합지원센터' }));
  const line1 = el('p', { className: 'ev123-consult-cta-bar__line' });
  line1.append(document.createTextNode('대표번호 '), tel1544);
  const line2 = el('p', { className: 'ev123-consult-cta-bar__line' });
  line2.append(document.createTextNode('직통번호 '), tel010);
  const line3 = el('p', { className: 'ev123-consult-cta-bar__line' });
  line3.append(document.createTextNode('이메일 '), mail);
  contacts.append(line1, line2, line3);

  const calcBtn = el('button', {
    type: 'button',
    className: 'ev123-btn ev123-btn--secondary ev123-btn--pill',
  }) as HTMLButtonElement;
  calcBtn.textContent = '충전기 설치 계산';
  calcBtn.addEventListener('click', () => navigate(ROUTES.newInstall));

  const actions = el('div', { className: 'ev123-consult-cta-bar__actions' });
  actions.appendChild(calcBtn);

  const ctaBar = el('div', { className: 'ev123-card ev123-card--elevated ev123-consult-cta-bar' });
  ctaBar.append(contacts, actions);

  wrap.append(
    el('section', { className: 'ev123-section ev123-section--tight ev123-section--band' }, [
      el('div', { className: 'ev123-container' }, [ctaBar]),
    ])
  );

  root.appendChild(wrap);
}

function textField(label: string, type: string, placeholder: string): HTMLElement {
  const wrap = el('div', { className: 'ev123-field' });
  const input = el('input', { className: 'ev123-input', type, placeholder }) as HTMLInputElement;
  wrap.append(el('label', { className: 'ev123-label', text: label }), input);
  return wrap;
}
